import React__default from 'react';
import { Box, Alert, IconButton } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import DefaultIcon from '../../../DefaultIcon/index.js';

var GenericErrorBoundary = function (_a) {
    var sx = _a.sx, _b = _a.testId, testId = _b === void 0 ? "GenericError" : _b, className = _a.className, resetErrorBoundary = _a.resetErrorBoundary, _c = _a.KIcon, KIcon = _c === void 0 ? DefaultIcon : _c;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(Box, { className: clsx("GenericError", className), "data-testid": testId, sx: sx },
        React__default.createElement(Alert, { severity: "error" },
            React__default.createElement(React__default.Fragment, null,
                t("components.withSuspense.genericError.label"),
                React__default.createElement(IconButton, { "aria-label": t("components.withSuspense.genericError.refresh"), title: t("components.withSuspense.genericError.refresh"), onClick: resetErrorBoundary },
                    React__default.createElement(KIcon, { sx: {
                            fontSize: function (theme) { return theme.typography.fontSize || "0.8rem"; }
                        }, className: "fa-refresh" }))))));
};

export { GenericErrorBoundary };
//# sourceMappingURL=index.js.map
